import { memo } from 'react';

import { useTheme } from '@mui/material/styles';

function PromotionalProductIcon({ width = 24, ...rest }: React.SVGProps<SVGSVGElement>) {
  const theme = useTheme();

  const PRIMARY = theme.palette.primary.darker;
  const SECONDARY = theme.palette.background.default;

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      version="1.1"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {/* Icon from Material Design Icons by Pictogrammers - https://github.com/Templarian/MaterialDesign/blob/master/LICENSE */}
      <path
        fill={PRIMARY}
        d="M 5.5,9 A 1.5,1.5 0 0 0 7,7.5 1.5,1.5 0 0 0 5.5,6 1.5,1.5 0 0 0 4,7.5 1.5,1.5 0 0 0 5.5,9 m 11.91,2.58 C 17.77,11.94 18,12.44 18,13 c 0,0.55 -0.22,1.05 -0.59,1.41 l -5,5 a 1.996,1.996 0 0 1 -2.83,0 L 2.59,12.42 C 2.22,12.05 2,11.55 2,11 V 6 C 2,4.89 2.89,4 4,4 h 5 c 0.55,0 1.05,0.22 1.41,0.58 z m -3.87,-5.87 1,-1 6.87,6.87 C 21.78,11.94 22,12.45 22,13 c 0,0.55 -0.22,1.05 -0.58,1.41 l -5.38,5.38 -1,-1 5.71,-5.79 z"
      />
      {/* Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE */}
      <path
        fill={SECONDARY}
        d="m 11.354749,15.370654 -0.451704,-0.438615 0.03681,-0.145402 q 0.03658,-0.145181 0.03681,-0.359007 2.27e-4,-0.213827 -0.08198,-0.468662 -0.08221,-0.254836 -0.307837,-0.474363 -0.06211,-0.06031 -0.127155,-0.106801 -0.06505,-0.04649 -0.126705,-0.08531 L 9.7737833,13.835502 9.3220796,13.396886 9.6608573,13.067924 q -0.3049,-0.06579 -0.6208665,-0.158998 -0.3159669,-0.09321 -0.6213183,-0.389272 -0.5194593,-0.504407 -0.5194593,-1.206193 0,-0.701786 0.5194593,-1.206194 0.4008871,-0.3892721 0.9316388,-0.4769951 0.530752,-0.087724 1.0163327,0.120619 l -0.242791,0.5756841 q -0.3105457,-0.137068 -0.6551957,-0.08224 -0.3446496,0.05483 -0.598281,0.301549 -0.3274851,0.317997 -0.3274855,0.767578 4e-7,0.449581 0.3274855,0.767578 0.2710221,0.263169 0.587215,0.307031 0.316192,0.04386 0.7283717,0.169964 l 0.942931,-0.915612 0.451704,0.438617 -0.784835,0.762095 q 0.06211,0.03838 0.121506,0.09036 0.0594,0.05197 0.121276,0.112512 0.282314,0.274134 0.409469,0.58928 0.127155,0.315146 0.15516,0.616914 l 1.106674,-1.07461 Q 12.9357,12.958283 12.9357,12.72801 q 10e-7,-0.230273 -0.141157,-0.455064 l 0.592861,-0.191894 q 0.248437,0.361858 0.175261,0.789509 -0.07318,0.42765 -0.401113,0.745646 z"
      />
    </svg>
  );
}

export default memo(PromotionalProductIcon);
